import './bootstrap';

import $ from 'jquery'
window.jQuery = window.$ = $

import Swal from 'admin-lte/plugins/sweetalert2/sweetalert2.min.js';
window.Swal = Swal;

import toastr from 'admin-lte/plugins/toastr/toastr.min.js'
window.toastr = toastr
toastr.options = {
  "closeButton": false,
  "debug": false,
  "newestOnTop": false,
  "progressBar": true,
  "positionClass": "toast-top-right",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}

import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import 'admin-lte/plugins/bs-custom-file-input/bs-custom-file-input.min.js'
import 'admin-lte/plugins/select2/js/select2.full.min.js'
import 'admin-lte/dist/js/adminlte.min.js'

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

import Permissions from '@/mixins/Permissions'

createInertiaApp({
  title: (title) => (title ? `${title} - KUNJUNGAN` : 'KUNJUNGAN'),
  resolve: name => require(`./Pages/${name}`),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .mixin(Permissions)
      .use(plugin)
      .mount(el)
  },
})
